import React, { useRef } from "react";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import "./Installation.css";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import Map from "../images/mapicon.svg";

import { useDownloadExcel } from "react-export-table-to-excel";

import dayjs from "dayjs";

export default function Installation() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permissions = useSelector((state) => state.permissions);
  const designation = useSelector((state) => state.designation);

  let [data, setData] = useState([]);
  let [dataCount, setDataCount] = useState([]);
  const formatDate = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const [customerdelete, setcustomerdelete] = useState(false);

  const navigate = useNavigate();

  const gotoviewInstallation = (leadId) => {
    navigate("/view_installation", {
      state: { leadId: leadId },
    });
  };

  const gotoaddinstallation = (e) => {
    e.preventDefault();
    navigate("/add_installation");
  };

  const getLeadStatusColor = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "completed":
        return "status-converted";
      case "progress":
        return "status-progress";

      case "open":
        return "status-open";

      case "cancelled":
        return "status-cancelled";
      default:
        return "";
    }
  };

  const getTabStatusColor = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      case "completed":
        return "status-converted";
      case "paid":
        return "status-converted";
      case "verified":
        return "status-converted";
      case "assigned":
        return "status-converted";
      case "pending":
        return "status-pending";

      default:
        return "";
    }
  };

  const [filters, setFilters] = useState({
    leadId: "",
    leadStatus: "",
    installorderDate: "",
    staffName: "",
    installcustomerName: "",
    installcontactNum: "",
    installalternateNum: "",
    installaddress: "",
    location: "",
    orderValue: "",
    installadvanceAmountPay: "",
    installnotes: "",
    installVerificationStatus: "",
    installWorkAsign: "",
    installWorkStatus: "",
    installaFeedback: "",
    installDueAmount: "",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

  // 1️⃣ First, map and add orderValue to every item
  const enrichedData = data.map((item) => {
    const planDetails = item.installplanDetails || {};

    const planMonth =
      Number(planDetails.installplanMonth?.replace(/\D/g, "")) || 0;
    const planAmount = Number(planDetails.installplanAmount) || 0;
    const staticIpCost = Number(planDetails.installstaticIpCost) || 0;
    const installationCost = Number(planDetails.installinstalationCost) || 0;
    const routerCost = Number(planDetails.installrouterCost) || 0;
    const otherCost = Number(planDetails.installothersCost) || 0;

    const totalPlanAmount = planMonth * planAmount;
    const baseAmount =
      totalPlanAmount +
      staticIpCost +
      installationCost +
      routerCost +
      otherCost;
    const gstAmount = baseAmount * 0.18;
    const orderValue = +(baseAmount + gstAmount).toFixed(2);

    return {
      ...item,
      orderValue,
    };
  });

  // 2️⃣ Now filter enrichedData (so orderValue is inside filterData too)
  const filteredData = enrichedData.filter((installation) => {
    return Object.keys(filters).every((key) => {
      const filterValue = filters[key]?.toString().toLowerCase().trim();
      if (!filterValue) return true;

      try {
        switch (key) {
          case "leadId":
            return (installation.leadId || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "leadStatus":
            return (installation.leadStatus || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installorderDate":
            return (installation.installorderDate || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "staffName":
            return (installation.installsalesName?.staffName || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installcustomerName":
            return (installation.installcustomerName || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installcontactNum":
            return (installation.installcontactNum || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installalternateNum":
            return (installation.installalternateNum || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installaddress":
            return (installation.installaddress || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "location":
            const locationStr = installation.location?.latitude
              ? `${installation.location.latitude}, ${installation.location.longitude}`
              : "N/A";
            return locationStr.toLowerCase().includes(filterValue);

          case "orderValue": // ✅ Now this works because it's already in enrichedData
            return (installation.orderValue || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installadvanceAmountPay":
            const advanceAmountPay =
              installation.installplanDetails?.installadvanceAmountPay || "";
            if (filterValue === "paid") {
              return advanceAmountPay.toLowerCase() === "pay";
            } else if (filterValue === "unpaid" || filterValue === "un paid") {
              return advanceAmountPay.toLowerCase() !== "pay";
            }
            return advanceAmountPay.toLowerCase().includes(filterValue);

          case "installnotes":
            return (installation.installleadStatus?.installnotes || "")
              .toString()
              .toLowerCase()
              .includes(filterValue);

          case "installVerificationStatus":
            const verificationStatus = installation.verification?.isCompleted
              ? "Verified"
              : "Pending";
            return verificationStatus.toLowerCase().includes(filterValue);

          case "installWorkAsign":
            const workAssignStatus =
              installation.workAssign?.fiberTeam?.fiberTeamAssigned &&
              installation.workAssign?.networkTeam?.networkTeamAssigned
                ? "Assigned"
                : "Pending";
            return workAssignStatus.toLowerCase().includes(filterValue);

          case "installWorkStatus":
            const workStatus = installation.workAssign?.isCompleted
              ? "Completed"
              : "Pending";
            return workStatus.toLowerCase().includes(filterValue);

          case "installaFeedback":
            const feedbackStatus = installation.feedback?.isCompleted
              ? "Completed"
              : "Pending";
            return feedbackStatus.toLowerCase().includes(filterValue);

          case "installDueAmount":
            const paymentStatus = installation.payment?.isCompleted
              ? "Paid"
              : "Pending";
            return paymentStatus.toLowerCase().includes(filterValue);

          default:
            return true;
        }
      } catch (error) {
        console.error(`Error filtering by ${key}:`, error);
        return true;
      }
    });
  });

  const filteredDataNew = data?.filter((customer) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true; // Skip empty filters
      return String(customer[key]).toLowerCase().includes(filters[key]);
    });
  });

  const handleDelete = async (leadId) => {
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "you want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        // API Call to delete user
        await axios.post(apiUrl + "delete-install", {
          leadId: leadId,
        });

        // Success message
        Swal.fire("Deleted!", "Your data has been deleted.", "success");
        setcustomerdelete(true);

        // if (onDeleteSuccess) {
        //   onDeleteSuccess();
        // }
      } catch (error) {
        // Error handling
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
        console.error("Delete Error:", error);
      }
    }
  };

  const gotoverification = (leadId, activeTabfromInstall) => {
    navigate("/view_installation", {
      state: {
        activeTabfromInstall: "verification",
        leadId: leadId, // pass the id here
      },
    });
  };

  useEffect(() => {
    axios.post(apiUrl + "view-install", {}).then((res) => {
      const add_installation = res.data.message || [];
      const sortedData = [...add_installation].reverse();

      setData(sortedData);

      // const counts = {
      //   active: customers.filter((c) => c.accountstatus === "Active").length,
      //   inactive: customers.filter((c) => c.accountstatus === "Inactive")
      //     .length,
      //   suspended: customers.filter((c) => c.accountstatus === "Suspended")
      //     .length,
      //   disabled: customers.filter((c) => c.accountstatus === "Disable").length,
      //   online: customers.filter((c) => c.devicestatus === "Online").length,
      //   offline: customers.filter((c) => c.devicestatus === "Offline").length,
      // };
      // setStatusCounts(counts);
    });
  }, [customerdelete]);

  useEffect(() => {
    axios.get(apiUrl + "installation-stats", {}).then((res) => {
      const add_installation = res.data.stats || [];

      setDataCount(add_installation);
    });
  }, []);

  const [columnVisibility, setColumnVisibility] = useState({
    // selectAll: true,
    leadId: true,

    accountManager: true,
    installationStatus: true,
    customerName: true,

    contactnum: true,
    alternatenum: true,
    address: true,
    location: true,
    verificationStatus: true,
    advanceStatus: true,
    dueAmount: true,
    feedback: true,
    workAssign: true,
    workStatus: true,
    totalCost: true,
    orderDate: true,

    notes: true,
  });

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };
  const [setting, setSetting] = useState(false);

  const settingPopup = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };

  let changedata = (data) => {
    if (data == "leadId") {
      return "  Lead Id";
    }
    if (data == "installationStatus") {
      return " Installation Dtatus";
    }
    if (data == "orderDate") {
      return " Order Date";
    }
    if (data == "accountManager") {
      return " Account Manager";
    }
    if (data == "leadStatus") {
      return " Lead Status";
    }
    if (data == "customerName") {
      return " Customer Name";
    }
    if (data == "emailid") {
      return " Email ID";
    }

    if (data == "contactnum") {
      return " Contact Number";
    }
    if (data == "alternatenum") {
      return " Alternate Number";
    }
    if (data == "address") {
      return " Address ";
    }
    if (data == "location") {
      return " Location";
    }
    if (data == "totalCost") {
      return " Total Cost";
    }

    if (data == "advanceStatus") {
      return " Advance Status";
    }
    if (data == "notes") {
      return " Notes";
    }

    if (data == "verificationStatus") {
      return " Verification Status";
    }

    if (data == "workAssign") {
      return " Work Assign";
    }

    if (data == "workStatus") {
      return " Work Status";
    }
    if (data == "feedback") {
      return " Feedback";
    }
    if (data == "dueAmount") {
      return " Due Amount";
    } else {
      return data;
    }
  };

  useEffect(() => {
    axios.post(apiUrl + "view-install", {}).then((res) => {
      const add_installation = res.data.message || [];

      const sortedData = [...add_installation].reverse();

      console.log("Sorted data:", sortedData);
      setData(sortedData);

      // const counts = {
      //   active: customers.filter((c) => c.accountstatus === "Active").length,
      //   inactive: customers.filter((c) => c.accountstatus === "Inactive")
      //     .length,
      //   suspended: customers.filter((c) => c.accountstatus === "Suspended")
      //     .length,
      //   disabled: customers.filter((c) => c.accountstatus === "Disable").length,
      //   online: customers.filter((c) => c.devicestatus === "Online").length,
      //   offline: customers.filter((c) => c.devicestatus === "Offline").length,
      // };
      // setStatusCounts(counts);
    });
  }, [customerdelete]);

  useEffect(() => {
    axios.get(apiUrl + "installation-stats", {}).then((res) => {
      const add_installation = res.data.stats || [];

      setDataCount(add_installation);
    });
  }, []);

  //       const [columnVisibility, setColumnVisibility] = useState({
  //           // selectAll: true,
  //           leadId: true,

  //           accountManager: true,
  //           installationStatus: true,
  //           customerName: true,

  //           contactnum: true,
  //           alternatenum: true,
  //           address: true,
  //           location: true,
  //           verificationStatus:true,
  //           advanceStatus:true,
  //           dueAmount:true,
  //           feedback:true,
  //           workAssign:true,
  //           workStatus:true,
  //           totalCost:true,
  //           orderDate:true,

  //           notes: true,

  //         });

  //         const handleColumnVisibilityChange = (e) => {
  //           const { name, checked } = e.target;
  //           setColumnVisibility((prev) => ({
  //             ...prev,
  //             [name]: checked,
  //           }));
  //         };
  //       const [setting, setSetting] = useState(false);

  //     const settingPopup = (e) => {
  //   e.preventDefault();
  //   setSetting(!setting);
  // };

  const handleMapClick = () => {
    navigate("/taskmapview?page=installation");
  };
  //Export PopUp
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Installation_data",
    sheet: "Installation",
  });
  const [shouldExport, setShouldExport] = useState(false);

  const handleExportConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to export the Installation details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, export it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
        setShouldExport(true); // Allow the export to proceed
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The export operation was cancelled.", "error");
        setShouldExport(false);
      }
    });
  };

  return (
    <div>
      <Topbar />
      <Container fluid className=" pt-1 customer-row ">
        <h3 className=" px-2  ">Installation</h3>

        {permissions?.Installation?.["Installation Statistics"]?.Read && (
          <Row className=" row-width">
            <Col className="dashborder mt-4   mb-5 mx-2 ">
              <Row className="yellow-card">
                <p
                  className="text-center box-txt "
                  style={{ marginTop: "8px" }}
                >
                  Open
                </p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.open}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1  ">
              <Row className="purple-card">
                <p className="text-center pt-3 box-txt">Verified</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.verified}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5  mx-1">
              <Row className="orange-card ">
                <p className="text-center pt-1 box-txt">Field Team Working</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {dataCount.fieldTeamWorking}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="blue-card row-margin">
                <p className="text-center pt-1 box-txt">Activation Pending</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">
                  {dataCount.activationPending}
                </h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="pink-card">
                <p className="text-center pt-1 box-txt">Payment Due</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.paymentDue}</h5>
              </Row>
            </Col>
            <Col className="dashborder mt-4 mb-5 mx-1">
              <Row className="green-card">
                <p className="text-center pt-1 px-1 box-txt">Completed</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.completed}</h5>
              </Row>{" "}
            </Col>
            <Col className="dashborder mx-1  mt-4 mb-5">
              <Row className="red-card">
                <p className="text-center pt-1 box-txt">Cancelled</p>
              </Row>
              <Row className="number">
                <h5 className="text-center pt-1">{dataCount.cancelled}</h5>
              </Row>
            </Col>
          </Row>
        )}

        <Row className=" button-bottom-custmer">
          <Col className="mt-2 mb-2" md={7}>
            {permissions?.Installation?.["Add Installation"]?.Write && (
              <button
                onClick={gotoaddinstallation}
                className="black-btn btnadd  black-btn1"
              >
                Add
              </button>
            )}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn black-btn1"
            >
              Refresh
            </button>
          </Col>

          <Col className="mt-2 text-end" md={4}>
            {/* <button
              className="black-btn black-btn1 btnadd"
              onClick={
                designation === "Super Admin" && filteredData.length > 0
                  ? handleExportConfirmation
                  : undefined
              }
              disabled={
                designation !== "Super Admin" || filteredData.length === 0
              }
              style={{
                opacity:
                  designation === "Super Admin" && filteredData.length > 0,
                cursor:
                  designation === "Super Admin" && filteredData.length > 0
                    ? "pointer"
                    : "not-allowed",
              }}
              title={
                designation !== "Super Admin"
                  ? "Only Super Admin can export"
                  : filteredData.length === 0
                  ? "No data to export"
                  : "Export"
              }
            >
              Export
            </button> */}
            &emsp;&emsp;
            <button onClick={settingPopup} className="black-btn black-btn1 ">
              Settings
            </button>
            {setting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button className="setting-close-btn" onClick={settingPopup}>
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input
                          className="checkbox-customer"
                          type="checkbox"
                          checked={Object.values(columnVisibility).every(
                            (v) => v
                          )}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setColumnVisibility(
                              Object.keys(columnVisibility).reduce(
                                (acc, key) => {
                                  acc[key] = isChecked;
                                  return acc;
                                },
                                {}
                              )
                            );
                          }}
                        />
                        <span
                          className="checkbox-down ms-1"
                          style={{ fontSize: "17px" }}
                        >
                          {Object.values(columnVisibility).every((v) => v)
                            ? "Unselect All"
                            : "Select All"}
                        </span>
                      </label>
                    </div>

                    <div className="setting-checkbox-grid">
                      {Object.keys(columnVisibility).map((key) => (
                        <label key={key} className="label-setting-popup">
                          <input
                            type="checkbox"
                            name={key}
                            checked={columnVisibility[key]}
                            onChange={handleColumnVisibilityChange}
                            className="checbox-popup"
                          />
                          <span className="checkbox-down1">
                            {changedata(key)}
                          </span>
                        </label>
                      ))}
                    </div>

                    <button
                      className="setting-submit-btn"
                      onClick={settingPopup}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* {setting && (
              <div className="setting-popup-overlay">
                <div className="setting-popup-container">
                  <button className="setting-close-btn" onClick={settingPopup}>
                    &times;
                  </button>
                  <div className="setting-popup-content">
                    <div className="setting-checkbox-row">
                      <label>
                        <input type="checkbox"  />
                        <span  className="checkbox-down"style={{ fontSize: "25" }}>Select All</span>
                      
                      </label>
                    </div>
                    <div className="setting-checkbox-grid">
                      {[
                        "Customer ID",
                        "Expiry Date",
                        "Customer Name",
                        "Device Status",
                        " Installation Address",
                        "Contact Number",
                        "Alternate Number",
                        "Mail ID",
                        "Account Manager",
                        "Refund Deposit",
                        "Activation Date",
                        "Last Renewal Date",
                        "Last Logoff Date",
                        "Billing Address",
                        "Plan Name",
                        "Account Status",
                        "Installation charges",
                        "Refund Description",
                        "Area",
                      ].map((label, index) => (
                        <label key={index}>
                          <input type="checkbox" /><span className="checkbox-down">{label}</span> 
                        </label>
                      ))}
                    </div>
                    <button className="setting-submit-btn">Submit</button>
                  </div>
                </div>
              </div>
            )} */}
          </Col>
          <Col >
            <img
              src={Map}
              alt="map"
              style={{ width: "30px", height: "30px" }}
              className="map-icon text-end"
              onClick={handleMapClick}
            />
          </Col>
        </Row>

        <br />

        {permissions?.Installation?.["Installation Module"]?.Read && (
          <div className="    scrolltable">
            <table className="table table-bordered" ref={tableRef}>
              <thead className="table-th text-center">
                {columnVisibility.leadId && (
                  <th className="table-th-content ">Lead ID</th>
                )}
                {columnVisibility.installationStatus && (
                  <th className="table-th-content">Installation Status</th>
                )}
                {columnVisibility.orderDate && (
                  <th className="table-th-content">Order Date</th>
                )}

                {columnVisibility.accountManager && (
                  <th className="table-th-content">Account Manager</th>
                )}
                {columnVisibility.customerName && (
                  <th className="table-th-content">Customer Name</th>
                )}
                {columnVisibility.contactnum && (
                  <th className="table-th-content">Contact Number</th>
                )}
                {columnVisibility.alternatenum && (
                  <th className="table-th-content">Alternate Number</th>
                )}
                {columnVisibility.address && (
                  <th className="table-th-content">Address</th>
                )}
                {columnVisibility.location && (
                  <th className="table-th-content">Location</th>
                )}

                {columnVisibility.totalCost && (
                  <th className="table-th-content">Total Cost</th>
                )}
                {columnVisibility.advanceStatus && (
                  <th className="table-th-content">Advance Status</th>
                )}
                {columnVisibility.notes && (
                  <th className="table-th-content">Notes</th>
                )}
                {columnVisibility.verificationStatus && (
                  <th className="table-th-content">Verification Status</th>
                )}

                {columnVisibility.workAssign && (
                  <th className="table-th-content">Work Assign</th>
                )}
                {columnVisibility.workStatus && (
                  <th className="table-th-content">Work Status</th>
                )}
                {columnVisibility.feedback && (
                  <th className="table-th-content">Feedback</th>
                )}

                {columnVisibility.dueAmount && (
                  <th className="table-th-content">Due Amount</th>
                )}

                {permissions?.Installation?.["Installation Module"]?.Delete && (
                  <th className="table-th-content ">Delete</th>
                )}
              </thead>

              <tbody className="tr:nth-child(even)">
                <tr>
                  {columnVisibility.leadId && (
                    <td>
                      <input
                        className="table-search background-change"
                        name="leadId"
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}
                  {columnVisibility.installationStatus && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="leadStatus"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>

                        <option value="Open">Open</option>
                        <option value="Progress">Progress</option>
                        <option value="Completed">Completed</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </td>
                  )}

                  {columnVisibility.orderDate && (
                    <td>
                      <input
                        className="table-search  background-change"
                        type="date"
                        name="installorderDate"
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}

                  {columnVisibility.accountManager && (
                    <td>
                      <input
                        className="table-search  background-change"
                        type="text"
                        style={{ textTransform: "capitalize" }}
                        name="staffName"
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}
                  {columnVisibility.customerName && (
                    <td>
                      <input
                        className="table-search  background-change"
                        name="installcustomerName"
                        type="text"
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}

                  {columnVisibility.contactnum && (
                    <td>
                      <input
                        className="table-search  background-change"
                        name="installcontactNum"
                        type="tel"
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}
                  {columnVisibility.alternatenum && (
                    <td>
                      <input
                        className="table-search  background-change"
                        name="installalternateNum"
                        onChange={handleFilterChange}
                        placeholder="Search "
                        type="tel"
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </td>
                  )}

                  {columnVisibility.address && (
                    <td>
                      <input
                        className=" table-search  background-change"
                        name="installaddress"
                        onChange={handleFilterChange}
                        placeholder="Search "
                        style={{ textTransform: "capitalize" }}
                        type="text"
                      />
                    </td>
                  )}

                  {columnVisibility.location && (
                    <td>
                      <input
                        className="table-search background-change "
                        style={{ textTransform: "capitalize" }}
                        name="location"
                        onChange={handleFilterChange}
                        placeholder="Search "
                        type="text"
                      />
                    </td>
                  )}
                  {columnVisibility.totalCost && (
                    <td>
                      <input
                        className="table-search  background-change"
                        style={{ textTransform: "capitalize" }}
                        name="orderValue"
                        onChange={handleFilterChange}
                        placeholder="Search "
                        type="tel"
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </td>
                  )}

                  {columnVisibility.advanceStatus && (
                    <td>
                      <select
                        className="table-search background-change"
                        name="installadvanceAmountPay"
                        onChange={handleFilterChange}
                      >
                        <option value="">All</option>
                        <option value="Pay">Paid</option>
                        <option value="Not Pay">Unpaid</option>{" "}
                      </select>
                    </td>
                  )}
                  {columnVisibility.notes && (
                    <td>
                      <input
                        className="table-search table-search-date  background-change"
                        type="text"
                        name="installnotes"
                        onChange={handleFilterChange}
                        placeholder="Search "
                      />
                    </td>
                  )}
                  {columnVisibility.verificationStatus && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="installVerificationStatus"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>
                        <option value="Verified">Verified</option>
                        <option value="Pending">Pending</option>
                      </select>
                    </td>
                  )}

                  {columnVisibility.workAssign && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="installWorkAsign"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>

                        <option value="Pending">Pending</option>
                        <option value="progress">Progress</option>
                        <option value="completed">completed</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                  )}
                  {columnVisibility.workStatus && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="installWorkStatus"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>

                        <option value="pending">Pending</option>
                        <option value="progress">Progress</option>
                        <option value="completed">completed</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                  )}
                  {columnVisibility.feedback && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="installaFeedback"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>

                        <option value="pending">Pending</option>
                        <option value="progress">Progress</option>
                        <option value="completed">completed</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                    </td>
                  )}

                  {columnVisibility.dueAmount && (
                    <td>
                      <select
                        className="table-search  background-change"
                        name="installDueAmount"
                        placeholder="Search "
                        onChange={handleFilterChange}
                      >
                        <option>Select</option>

                        <option value="Paid">Paid</option>
                        <option value="unpaid">Un Paid</option>
                      </select>
                    </td>
                  )}
                </tr>

                {Array.isArray(filteredData) && filteredData.length > 0 ? (
                  filteredData.map((d, i) => (
                    <tr key={i}>
                      {columnVisibility.leadId && (
                        <td
                          onClick={() => {
                            if (
                              permissions?.Installation?.["Installation Module"]
                                ?.Write
                            ) {
                              gotoviewInstallation(d.leadId);
                            }
                          }}
                          style={{
                            cursor: permissions?.Installation?.[
                              "Installation Module"
                            ]?.Write
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          {d.leadId}
                        </td>
                      )}
                      {columnVisibility.installationStatus && (
                        <td>
                          {" "}
                          <span className={getLeadStatusColor(d.leadStatus)}>
                            <span style={{ textTransform: "capitalize" }}>
                              {d.leadStatus}
                            </span>
                          </span>
                        </td>
                      )}
                      {columnVisibility.orderDate && (
                        <td>{formatDate(d.createdDate)}</td>
                      )}
                      {columnVisibility.accountManager && (
                        <td>{d.installsalesName?.staffName || "-"}</td>
                      )}

                      {columnVisibility.customerName && (
                        <td>{d.installcustomerName}</td>
                      )}
                      {columnVisibility.contactnum && (
                        <td>{d.installcontactNum}</td>
                      )}
                      {columnVisibility.alternatenum && (
                        <td>{d.installalternateNum}</td>
                      )}
                      {columnVisibility.address && <td>{d.installaddress}</td>}
                      {columnVisibility.location && (
                        <td>
                          {d.location?.latitude
                            ? `${d.location.latitude}, ${d.location.longitude}`
                            : "N/A"}
                        </td>
                      )}
                      {columnVisibility.advanceStatus && (
                        <td>{d.orderValue}</td>
                      )}
                      {columnVisibility.advanceStatus && (
                        <td className="text-center">
                          {d.installplanDetails?.installadvanceAmountPay ===
                          "Pay" ? (
                            <span
                              className="status-converted"
                              style={{
                                backgroundColor: "#28a745",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "5px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                display: "inline-block",
                                width: "100px",
                              }}
                            >
                              Paid
                            </span>
                          ) : (
                            <span
                              className="status-pending"
                              style={{
                                backgroundColor: "#dc3545",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "5px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                display: "inline-block",
                                width: "100px",
                              }}
                            >
                              Unpaid
                            </span>
                          )}
                        </td>
                      )}

                      {columnVisibility.notes && (
                        <td>{d.installleadStatus?.installnotes || "-"}</td>
                      )}
                      {columnVisibility.verificationStatus && (
                        <td
                          onClick={() => {
                            if (d.verification?.isCompleted) {
                              gotoverification(d.leadId);
                            }
                          }}
                          style={{
                            cursor: d.verification?.isCompleted
                              ? "pointer"
                              : "default",
                          }}
                        >
                          <span
                            className={getTabStatusColor(
                              d.verification?.isCompleted
                                ? "Verified"
                                : "Pending"
                            )}
                          >
                            {d.verification?.isCompleted
                              ? "Verified"
                              : "Pending"}
                          </span>
                        </td>
                      )}
                      {columnVisibility.workAssign && (
                        <td>
                          <span
                            className={getTabStatusColor(
                              String(
                                d.workAssign?.fiberTeam?.fiberTeamAssigned
                              ) === "true" &&
                                String(
                                  d.workAssign?.networkTeam?.networkTeamAssigned
                                ) === "true"
                                ? "Assigned"
                                : "Pending"
                            )}
                          >
                            {(d.workAssign?.fiberTeam?.fiberTeamAssigned ===
                              true ||
                              d.workAssign?.fiberTeam?.fiberTeamAssigned ===
                                "true") &&
                            (d.workAssign?.networkTeam?.networkTeamAssigned ===
                              true ||
                              d.workAssign?.networkTeam?.networkTeamAssigned ===
                                "true")
                              ? "Assigned"
                              : "Pending"}
                          </span>
                        </td>
                      )}

                      {columnVisibility.workStatus && (
                        <td>
                          {/* <span className={getTabStatusColor(d.workDetails?.isCompleted ? "Completed" : "Pending")}>
    {d.workDetails?.isCompleted ? "Completed" : "Pending"}
  </span> */}

                          <span
                            className={getTabStatusColor(
                              d.workAssign?.isCompleted
                                ? "Completed"
                                : "Pending"
                            )}
                          >
                            {d.workAssign?.isCompleted
                              ? "Completed"
                              : "Pending"}
                          </span>
                        </td>
                      )}

                      {columnVisibility.feedback && (
                        <td>
                          <span
                            className={getTabStatusColor(
                              d.feedback?.isCompleted ? "Completed" : "Pending"
                            )}
                          >
                            {d.feedback?.isCompleted ? "Completed" : "Pending"}
                          </span>
                        </td>
                      )}
                      {columnVisibility.dueAmount && (
                        <td>
                          <span
                            className={getTabStatusColor(
                              d.payment?.isCompleted ? "Paid" : "Pending"
                            )}
                          >
                            {d.payment?.isCompleted ? "Paid" : "Pending"}
                          </span>
                        </td>
                      )}

                      {permissions?.Installation?.["Installation Module"]
                        ?.Delete && (
                        <td>
                          <button
                            className="deletebtn text-center"
                            onClick={() => handleDelete(d.leadId)}
                          >
                            <MdDelete size={20} />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="16" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </Container>
    </div>
  );
}
